import { render, staticRenderFns } from "./rebate_policy.vue?vue&type=template&id=2ec17943&"
import script from "./rebate_policy.vue?vue&type=script&lang=js&"
export * from "./rebate_policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec17943')) {
      api.createRecord('2ec17943', component.options)
    } else {
      api.reload('2ec17943', component.options)
    }
    module.hot.accept("./rebate_policy.vue?vue&type=template&id=2ec17943&", function () {
      api.rerender('2ec17943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/rebate/rebate_policy/rebate_policy.vue"
export default component.exports